module.exports = __webpack_public_path__ + "img/xrp.1d3348ff.svg";